import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { ExpenseForm } from '@/features/accounting-spend/expense-form'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/expenses/$documentId')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_money_document.view')) {
      throw redirect({ to: '/accounting/expenses', search })
    }
  },
  component: ExpensesDocumentRoute,
})

function ExpensesDocumentRoute() {
  const { documentId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate()

  return (
    <ExpenseForm
      documentId={documentId}
      onOpenChange={(open) => {
        if (!open) void navigate({ to: '/accounting/expenses', search })
      }}
    />
  )
}
